var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as authActions from "@rentiohq/shared-frontend/dist/redux/auth/auth.actions";
import * as authApi from "@rentiohq/shared-frontend/dist/redux/auth/auth.api";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { isValidEmail } from "@rentiohq/shared-frontend/dist/utils/email.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import { Button, DisplayText, Field, Fieldset, Form } from "../../components";
import * as t from "../../services/translationService";
import { StyledAuthActions, StyledAuthBody, StyledAuthContent, StyledAuthFrame, StyledAuthLogo, StyledAuthMain, StyledAuthMedia, StyledAuthMediaWrap, } from "./Auth.styled";
import { InternalModeButton } from "./components/InternalModeButton";
var editEmailSchema = Yup.object().shape({
    email: Yup.string()
        .required(t.formErrorRequired(t.email()))
        .test("is-valid-email", t.formErrorInvalidEmail(), isValidEmail),
});
var EditEmail = function () {
    var _a;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var user = authHooks.useSelf().user;
    var handleFormSubmit = function (_a, actions_1) { return __awaiter(void 0, [_a, actions_1], void 0, function (_b, actions) {
        var updatedUser, _c;
        var email = _b.email;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authApi.updateUser({
                            unverifiedEmail: email,
                        })];
                case 1:
                    updatedUser = _d.sent();
                    dispatch(authActions.updateUser.actions.success({ user: updatedUser }));
                    // The backend sends the verification email automatically (afterSave hook)
                    // once unverifiedEmail is set, so no explicit resend is needed here.
                    navigate("/auth/verify/email");
                    return [3 /*break*/, 3];
                case 2:
                    _c = _d.sent();
                    showAlert({ type: "error", message: getLocalizedText("general.error") });
                    return [3 /*break*/, 3];
                case 3:
                    actions.setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderForm = function (_a) {
        var isSubmitting = _a.isSubmitting;
        return (
        // @ts-ignore
        _jsxs(Form, { children: [_jsx(Fieldset, { children: _jsx(Field, { name: "email", type: "email", label: t.email(), autoFocus: true }) }), _jsx(Button, { type: "submit", isDisabled: isSubmitting, appearance: "primary", isFullWidth: true, children: getLocalizedText("system.next") })] }));
    };
    return (_jsxs(StyledAuthFrame, { children: [_jsx(StyledAuthContent, { children: _jsxs(StyledAuthMain, { children: [_jsx(InternalModeButton, {}), _jsx(StyledAuthLogo, {}), _jsxs(StyledAuthBody, { children: [_jsx(DisplayText, { children: t.authEditEmailTitle() }), _jsx(Formik, { initialValues: { email: (_a = user === null || user === void 0 ? void 0 : user.unverifiedEmail) !== null && _a !== void 0 ? _a : "" }, onSubmit: handleFormSubmit, validationSchema: editEmailSchema, render: renderForm }), _jsx(StyledAuthActions, { children: _jsx(Button, { appearance: "link", onClick: function () { return navigate("/auth/verify/email"); }, children: getLocalizedText("system.cancel") }) })] })] }) }), _jsx(StyledAuthMediaWrap, { children: _jsx(StyledAuthMedia, {}) })] }));
};
// eslint-disable-next-line import/no-default-export
export default EditEmail;
